export default __webpack_public_path__ + "static/media/thum3.32da8d1c.jpg";